/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PhoneDto,
    PhoneDtoFromJSON,
    PhoneDtoFromJSONTyped,
    PhoneDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContactPersonDto
 */
export interface ContactPersonDto {
    /**
     * 
     * @type {string}
     * @memberof ContactPersonDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonDto
     */
    familyname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonDto
     */
    middlename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonDto
     */
    forename?: string | null;
    /**
     * 
     * @type {PhoneDto}
     * @memberof ContactPersonDto
     */
    phone?: PhoneDto;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonDto
     */
    contractorId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonDto
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonDto
     */
    userRoleName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContactPersonDto
     */
    shouldInvite?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonDto
     */
    orgName?: string | null;
}

export function ContactPersonDtoFromJSON(json: any): ContactPersonDto {
    return ContactPersonDtoFromJSONTyped(json, false);
}

export function ContactPersonDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactPersonDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'familyname': !exists(json, 'familyname') ? undefined : json['familyname'],
        'middlename': !exists(json, 'middlename') ? undefined : json['middlename'],
        'forename': !exists(json, 'forename') ? undefined : json['forename'],
        'phone': !exists(json, 'phone') ? undefined : PhoneDtoFromJSON(json['phone']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'contractorId': !exists(json, 'contractorId') ? undefined : json['contractorId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'userRoleName': !exists(json, 'userRoleName') ? undefined : json['userRoleName'],
        'shouldInvite': !exists(json, 'shouldInvite') ? undefined : json['shouldInvite'],
        'orgName': !exists(json, 'orgName') ? undefined : json['orgName'],
    };
}

export function ContactPersonDtoToJSON(value?: ContactPersonDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'familyname': value.familyname,
        'middlename': value.middlename,
        'forename': value.forename,
        'phone': PhoneDtoToJSON(value.phone),
        'email': value.email,
        'contractorId': value.contractorId,
        'userId': value.userId,
        'userRoleName': value.userRoleName,
        'shouldInvite': value.shouldInvite,
        'orgName': value.orgName,
    };
}


